import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//import ReferenceGrid from "./components/ReferenceGrid";
import ReferenceGridMui from "./components/ReferenceGridMui";
import PaymentAdvance from "./components/PaymentAdvance";
import PaymentRequest from "./components/PaymentRequest";
import SidebarMenu from "./components/SidebarMenu";
import Welcome from "./components/Welcome";
import PendingBillingDashboard from "./components/PendingBillingDashboard";
import TraficosGrid from "./components/TraficosGrid";
import TrafficGrid from "./components/TrafficGrid";
import TrafficDetails from "./components/TrafficDetails";
import ShipmentTable from "./components/ShipmentTable";
import ShipmentVisualizer from "./components/ShipmentVisualizer";
import BarcodeScanner from "./components/BarcodeScanner";
import Login from "./components/Login";
import axios from "axios";
import { useAuth, AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import SidebarWrapper from "./components/SidebarWrapper";
import { DataProvider } from "./contexts/DataContext"; // Updated import path
import withAuthProtection from "./components/AuthHoc";
import TrafficDataGrid from "./components/TrafficDataGrid";
import NetRevenue from "./components/NetRevenue";
//
import NetRevenueDashboard from "./components/NetRevenueDashboard";
import { Analytics } from "@vercel/analytics/react";
import ShipmentDetails from "./components/ShipmentDetails";
import ShipmentGrid from "./components/ShipmentGrid";
import FFDashboard from "./components/FFDashboard";
import PaymentAdvanceGrid from "./components/PaymentAdvanceGrid";
import PaymentRequestGrid from "./components/PaymentRequestGrid";
import PaymentRequestsDashboard from "./components/PaymentRequestsDashboard";
import InventoryGrid from "./components/InventoryGrid";
import XMLFileProcessor from "./components/XMLProcessor";
import CustomerItemCatalogueGrid from "./components/CustomerItemCatalogueGrid";
import CustomerReportAirBookingGrid from "./components/CustomerReportAirBookingGrid";
import CustomerReportWeeklyOperations from "./components/CustomerReportWeeklyOperations";
import CustomerItemCatalogueCrossedParts from "./components/CustomerItemCatalogueCrossedParts ";
import ClassificationDetails from "./components/ClassificationDetails";
import TrafficDashboard from "./components/TrafficDashboard";
import CartaPorteReport from "./components/CartaPorteReport";
import DataRefreshManager from "./components/DataRefreshManager";
import TrafficGridBooking from "./components/TrafficGridBooking";
import TrafficComponent from "./components/TrafficComponent";
import TrafficVisualControlTower from "./components/VisualTrafficControlTower";
import EnhancedDashboard from "./components/EnhancedDashbaord";
import TrafficManagementDashboard from "./components/TrafficManagementDashboard";
import DataQualityDashboard from "./components/data-quality/DataQualityDashboard";
import BookingControlDeck from "./components/BookingControlDeck";
import CusmxControlTowerDashboardEnhanced from "./components/cusmxControlTowerDashboardEnhanced";
import UltraStunningDashboard from "./components/UltraStunningDashboard";

function App() {
  const ProtectedRoutes = withAuthProtection(() => (
    <Routes>
      {/*<Route path="/" element={<PendingBillingDashboard />} />*/}
      <Route path="/" element={<TrafficComponent />} />
      <Route path="/traficosGrid" element={<TraficosGrid />} />
      <Route path="/dataRefreshManager" element={<DataRefreshManager />} />
      <Route path="/trafficDashboard" element={<Welcome />} />
      <Route path="/trafficDataGrid" element={<TrafficDataGrid />} />
      <Route path="/netRevenue" element={<NetRevenue />} />
      <Route path="/netRevenueDashboard" element={<NetRevenueDashboard />} />
      <Route path="/XMLFileProcessor" element={<XMLFileProcessor />} />
      <Route path="/paymentAdvances" element={<PaymentAdvanceGrid />} />
      <Route
        path="/customerItemCatalogueGrid"
        element={<CustomerItemCatalogueGrid />}
      />{" "}
      <Route
        path="/CustomerReportWeeklyOperations"
        element={<CustomerReportWeeklyOperations />}
      />
      <Route
        path="/CustomerReportAirBookingGrid"
        element={<CustomerReportAirBookingGrid />}
      />
      <Route
        path="/customerItemCatalogueCrossedParts/:customer_id/:customer_rfc/:item_number"
        element={<CustomerItemCatalogueCrossedParts />}
      />
      <Route
        path="/classificationDetails/:item_mx_hts_code/"
        element={<ClassificationDetails />}
      />
      <Route path="/cusmxDashboard" element={<TrafficDashboard />} />
      <Route
        path="/cusmxControlTowerDashboard"
        element={<EnhancedDashboard />}
      />
      <Route
        path="/cusmxControlTowerDashboardEnhanced"
        element={<CusmxControlTowerDashboardEnhanced />}
      />
      <Route
        path="/ultraStunningDashboard"
        element={<UltraStunningDashboard />}
      />
      {<Route path="/traffic" element={<TrafficGrid />} />}
      <Route path="/trafficControlTower" element={<TrafficComponent />} />
      <Route
        path="/visualTrafficControlTower"
        element={<TrafficVisualControlTower />}
      />
      <Route path="/trafficBooking" element={<TrafficGridBooking />} />
      <Route
        path="/trafficManagementDashboard"
        element={<TrafficManagementDashboard />}
      />
      <Route path="/ebookingDataQuality" element={<DataQualityDashboard />} />
      <Route path="/cartaPorte" element={<CartaPorteReport />} />
      <Route path="/bookingControlDeck" element={<BookingControlDeck />} />
    </Routes>
  ));

  return (
    <AuthProvider>
      <DataProvider>
        {" "}
        {/* Wrap your components with DataProvider */}
        <Router>
          <div style={{ display: "flex" }}>
            <SidebarWrapper />
            <div
              style={{
                marginLeft: "65px",
                width: "calc(100% - 65px)",
                transition:
                  "margin-left 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
              }}
            >
              {" "}
              {/* Adjust content to be displayed next to the dynamic sidebar */}
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route path="/referenceList" element={<ReferenceGridMui />} />
                <Route path="/paymentAdvance" element={<PaymentAdvance />} />
                <Route path="/paymentRequest" element={<PaymentRequest />} />
                <Route path="/trafficDetails" element={<TrafficDetails />} />
                <Route
                  path="/shipmentDetails/:id"
                  element={<ShipmentDetails />}
                />
                <Route path="/shipment-table" element={<ShipmentTable />} />
                <Route
                  path="/freightVisualizer"
                  element={<ShipmentVisualizer />}
                />
                <Route path="/shipments" element={<ShipmentGrid />} />
                <Route path="/ffDashboard" element={<FFDashboard />} />
                <Route
                  path="/paymentRequests"
                  element={<PaymentRequestGrid />}
                />
                <Route path="/barcodeScanner" element={<BarcodeScanner />} />
                <Route
                  path="/paymentRequestDashboard"
                  element={<PaymentRequestsDashboard />}
                />
                <Route path="/inventoryGrid" element={<InventoryGrid />} />

                <Route path="*" element={<ProtectedRoutes />} />
              </Routes>
            </div>
          </div>
        </Router>
        <Analytics />
      </DataProvider>
    </AuthProvider>
  );
}
// Exporting the App component as the default export
export default App;
